import { Pagination, createTable, Link as LinkMagik } from "@inmagik/magik-ui"
import { useMemo, useState } from "react"
import type { Document, FiltersBase } from "../../types"
import { PAGE_SIZE } from "../../constants"
import { Link } from "react-router-dom"

const Table = createTable<Document>()

export function TableDocuments({
  documents,
  setFilters,
  filters,
  count,
  fullCount,
}: {
  documents: Document[]
  setFilters: (nextFilters: Partial<FiltersBase>) => void
  filters: FiltersBase
  count: number
  fullCount: number
}) {
  // const [sort, setSort] = useState<string>("")
  const [selectedRows, setSelectedRows] = useState<number[]>([])

  const numPages = useMemo(() => {
    if (!documents) {
      return 1
    }
    return Math.ceil(count / PAGE_SIZE)
  }, [documents, count])

  return (
    <Table
      data={documents}
      className="w-100 overflow-scroll flex-1"
      orderBy={filters.ordering.replace("-", "")}
      orderDirection={filters.ordering.startsWith("-") ? "desc" : "asc"}
      onOrderChange={(field, direction) => {
        if (field) {
          if (direction === "desc") {
            setFilters({ ...filters, ordering: `-${field}` })
          } else {
            setFilters({ ...filters, ordering: field })
          }
        } else {
          setFilters({ ...filters, ordering: "" })
        }
      }}
    >
      <Table.HeaderConfig sticky />

      <Table.BodyConfig />

      <Table.Selection
        selectionField="id"
        selectedRows={selectedRows}
        onSelectionChange={(rows) => {
          setSelectedRows(rows)
        }}
      />

      <Table.Column
        title="Titolo"
        name="title"
        sortable
        width="minmax(400px, 1fr)"
        render={(document) => (
          <Link to={`/documents/documents/${document.id}/`}>
            <LinkMagik className="text-dark">{document.title}</LinkMagik>
          </Link>
        )}
        stickyLeft
      />

      <Table.Column
        title="Anno"
        name="year"
        sortable
        width="minmax(100px, 1fr)"
        render={(document) => <>{document.year || "-"}</>}
      />

      <Table.Column
        title="Immagine"
        name="cover_image"
        width="minmax(150px, 1fr)"
        render={(document) => (
          <>
            {document.cover_image ? (
              <img
                src={document.cover_image.media_file as string}
                alt={document.cover_image.title}
                style={{ width: 100, height: "auto" }}
              />
            ) : document.media_data && document.media_data.length > 0 ? (
              <img
                src={document.media_data[0].media_file as string}
                alt={document.media_data[0].title}
                style={{ width: 100, height: "auto" }}
              />
            ) : (
              <>-</>
            )}
          </>
        )}
      />

      <Table.Column
        title="Bozza"
        name="draft"
        sortable
        width="minmax(100px, 1fr)"
        render={(document) => <>{document.draft ? "Sì" : "No"}</>}
      />

      <Table.Footer.Left>
        Stai visualizzando {count} di {fullCount} Fototesti
      </Table.Footer.Left>
      <Table.Footer.Center>
        <Pagination page={filters.page} numPages={numPages} onPageChange={(page) => setFilters({ ...filters, page })} />
      </Table.Footer.Center>
    </Table>
  )
}
